const styles = theme => ({
    offscreen: {
        position: 'absolute',
        left: -99999999
    },
    content: {
        minWidth: 500
    },
    error: {
        color: theme.palette.error.main
    }

});

export default styles;